/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Landing_Compare_WithoutInputs */

const en_landing_compare_without = /** @type {(inputs: Landing_Compare_WithoutInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Without Alchema`)
};

const de_landing_compare_without = /** @type {(inputs: Landing_Compare_WithoutInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ohne Alchema`)
};

const fr_landing_compare_without = /** @type {(inputs: Landing_Compare_WithoutInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sans Alchema`)
};

const es_landing_compare_without = /** @type {(inputs: Landing_Compare_WithoutInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sin Alchema`)
};

const it_landing_compare_without = /** @type {(inputs: Landing_Compare_WithoutInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Senza Alchema`)
};

const nl_landing_compare_without = /** @type {(inputs: Landing_Compare_WithoutInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Zonder Alchema`)
};

const pl_landing_compare_without = /** @type {(inputs: Landing_Compare_WithoutInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bez Alchema`)
};

const fi_landing_compare_without = /** @type {(inputs: Landing_Compare_WithoutInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ilman Alchemaa`)
};

const da_landing_compare_without = /** @type {(inputs: Landing_Compare_WithoutInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Uden Alchema`)
};

const sv_landing_compare_without = /** @type {(inputs: Landing_Compare_WithoutInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Utan Alchema`)
};

/**
* | output |
* | --- |
* | "Without Alchema" |
*
* @param {Landing_Compare_WithoutInputs} inputs
* @param {{ locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }} options
* @returns {LocalizedString}
*/
export const landing_compare_without = /** @type {((inputs?: Landing_Compare_WithoutInputs, options?: { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Landing_Compare_WithoutInputs, { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_landing_compare_without(inputs)
	if (locale === "fr") return fr_landing_compare_without(inputs)
	if (locale === "es") return es_landing_compare_without(inputs)
	if (locale === "it") return it_landing_compare_without(inputs)
	if (locale === "nl") return nl_landing_compare_without(inputs)
	if (locale === "pl") return pl_landing_compare_without(inputs)
	if (locale === "fi") return fi_landing_compare_without(inputs)
	if (locale === "da") return da_landing_compare_without(inputs)
	if (locale === "sv") return sv_landing_compare_without(inputs)
	return en_landing_compare_without(inputs)
});